<template>
  <section class="card">
    <section class="city">{{ prog.location.city || 'ville' | uppercase}}</section>
    <router-link tag="section" :to="{ path: '/programme/details/'+prog.numero }" class="image">
      <img alt="" :src="image(prog.thumbnail)" />
    </router-link>
    <span class="law"><em v-for="(law, l) in prog.laws" :key="l" ><i v-if="l > 0">,</i> {{ config.laws[law] }}</em> <i v-if="prog.laws[0] === 0">dispositif</i></span>
    <section class="inside">
      <span class="title">{{ prog.name }}</span>
      <span class="location"><i class="icon-location"></i> À {{ prog.location.city || 'ville' }}, {{ prog.location.district || 'quartier' }}</span>
      <ul>
        <li>DU<span>{{ prog.lot.type.min | type }} au {{ prog.lot.type.max | type }}</span></li>
        <li>DE<span>{{ parseInt(prog.lot.size.min) }}m² à {{ parseInt(prog.lot.size.max) }}m²</span></li>
        <li>À PARTIR DE<span>{{ prog.lot.price.min.toLocaleString() }} €</span></li>
      </ul>
      <p>{{ prog.summary }}</p>
      <router-link tag="button" :to="{ path: '/programme/details/'+prog.numero }">EN SAVOIR PLUS</router-link>
    </section>
  </section>
</template>

<script>
import { image } from '@/helpers.js'

export default {
  name: 'ProgrammesCardPartner',
  props: {
    prog: Object
  },
  data () {
    return {
    }
  },
  computed: {
    config: function () {
      return this.$store.getters.get_settings()
    }
  },
  methods: {
    image
  }
}
</script>
